// ets_tracing: off
import { mapWithIndex } from "@effect-ts/core/Collections/Immutable/Dictionary";
export const Predicates = tag => keys => ({
  is: mapWithIndex((key, _) => rest => rest[tag] === key)(keys),
  verified: a => a[tag] in keys,
  isAnyOf: keys => rest => keys.indexOf(rest[tag]) !== -1
});
//# sourceMappingURL=index.mjs.map